// Single place to change the address every "contact us" surface points at.
export const SUPPORT_EMAIL = 'codesimply24@gmail.com';
